import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const servicos = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/services', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function createItem(servico) {
    try {
      await http.post('/services', servico, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return error?.response?.data?.message ?? false;
    }
  }

  async function updateItem(servico) {
    try {
      await http.put('/services/'+servico.id, servico, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      await http.delete('/services/'+id, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, createItem, updateItem, deleteItem}
}
